import { ReactComponent as Copy } from 'assets/icons/copy.svg';
import { copyTextToClipboard, getTextContent } from 'helpers';
import { useEffect, useRef, useState } from 'react';
import './styles.scss';

const BlogAPISection = ({ data }) => {
    const [activeLanguage, setActiveLanguage] = useState(0);
    const [apiData, setApiData] = useState({
        selectedLanguage: data[0],
    });
    const [copyButtonText, setCopyButtonText] = useState('Copy');

    const handleLanguageChange = (language, index) => {
        setApiData((prevAPIData) => ({ ...prevAPIData, selectedLanguage: language }));
        setActiveLanguage(index);
    };

    const handleCopy = () => {
        const contentToCopy = document.getElementById('contentToCopy');
        if (contentToCopy) {
            const textToCopy = contentToCopy.innerText;
            copyTextToClipboard(textToCopy);
            setCopyButtonText('Copied');
            setTimeout(() => {
                setCopyButtonText('Copy');
            }, 2000);
        }
    };

    useEffect(() => {
        if (!apiData.selectedLanguage && data.length > 0) {
            handleLanguageChange(data[0], 0);
        }
    }, [data]);

    if (!data) return null;

    return (
        <div className="blog-apiintegration-console">
            <div className="blog-apiintegration-console-body">
                <div id="contentToCopy">
                    {apiData.selectedLanguage?.code ?
                        getTextContent(apiData.selectedLanguage.code) :
                        (<code>Soon</code>)
                    }
                </div>
                <button onClick={handleCopy} className='blog-apiintegration-console-body-copy-btn'>
                    <Copy />{copyButtonText}
                </button>
            </div>
            <div className='blog-apiintegration-console-footer'>
                {data.map((language, index) => (
                    <div
                        key={index}
                        className={`blog-apiintegration-console-footer__tag ${activeLanguage === index ? "active" : ""}`}
                        onClick={() => handleLanguageChange(language, index)}
                    >
                        <span>{language.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default BlogAPISection;